import { createStateHook, type HookStateFunction } from 'react-sweet-state';

import type { ViewType } from '../../../../common/types/context';
import { store } from '../../main';
import type { ReadyPublicDataForOnInit } from './types';
import { selectReadyPublicDataForOnInit } from './utils';

export const useReadyPublicDataForOnInit: HookStateFunction<
	ReadyPublicDataForOnInit | null,
	{ viewType: ViewType }
> = createStateHook(store, {
	selector: selectReadyPublicDataForOnInit,
});
